import BaseService from './BaseService';
class UserDataViewService extends BaseService{

}

export default new UserDataViewService('health_backend','health/user_data_views');